import { useTranslation } from 'react-i18next';
import { SttList } from '../all';

type Consent = {
    id: number;
    name: string;
};

type Props = {
    consents: Consent[];
    onAdd?: () => void;
    onSelect?: (consent: Consent) => void;
    onDelete?: (consent: Consent) => void;
};

/**
 * SttConsentList - list of consent templates
 * @param consents
 * @param onAdd
 * @param onDelete
 */
export function SttConsentList({
    consents,
    onAdd,
    onSelect,
    onDelete,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SttList
            {...({
                fullWidth: true,
                title: t('consent.consentTemplates'),
                data: (consents || []).map((consent: any) => ({
                    caption: consent.name,
                    objToSelect: consent,
                })),
                onAdd,
                onSelect: (consent: Consent) => onSelect && onSelect(consent),
                onDelete: (consent: Consent) => onDelete && onDelete(consent),
            } as any)}
        />
    );
}
